var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRightMainBanner = function SvgArrowRightMainBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m49.26 39.999-21.23-29.09a2.681 2.681 0 0 1-.407-.819 3.244 3.244 0 0 1-.138-.964c.002-.33.053-.658.15-.962.098-.304.24-.579.417-.81.178-.23.388-.411.619-.533.23-.121.476-.18.724-.174.248.006.493.078.72.211.227.133.431.325.602.564l22.5 30.834c.341.466.532 1.092.532 1.743s-.191 1.277-.532 1.743l-22.5 30.834c-.17.24-.375.43-.602.564a1.492 1.492 0 0 1-.72.211 1.469 1.469 0 0 1-.724-.174 1.917 1.917 0 0 1-.619-.534 2.654 2.654 0 0 1-.417-.81 3.226 3.226 0 0 1-.15-.96c-.002-.331.045-.659.138-.965.094-.306.232-.585.407-.819l21.23-29.09Z",
    fill: "#fff",
    opacity: 0.2
  })));
};
export default SvgArrowRightMainBanner;